import React, {useEffect, useRef, useState} from 'react';
import {auth, db} from "../../services/firebase";
import {ChatContent, ChatTitle, Main} from "../../components";
import ChatBody from "../../components/chat-body/chat-body";
import {
    SelectChat,
    SelfAvatar,
    SelfAvatarContainer,
    ModalDivider,
    SearchInput,
    SearchIconBox,
    SearchIcon,
    ModalTitle,
    ChatContactAvatar,
    ChatContactImage,
    ChatContactName,
    HeaderActionIcon
} from './private-chat.styles';
import {Modal} from 'react-responsive-modal';
import UserItem from "../../components/user-item/user-item";
import {RELATION_KEY} from "../../constants/chat";
import {useTranslation} from "react-i18next";
import Notification from "../../helpers/notifications";
import Placeholder from "../../assets/Images/profile-placeholder.png";

const PrivateChat = () => {

    const [addFriendModal, setAddFriendModal] = useState(false);
    const [openInMobile, setOpenInMobile] = useState(false);
    const [selectedChat, setSelectedChat] = useState(null);
    const [searchFriend, setSearchFriend] = useState('');
    const [searchFriendList, setSearchFriendList] = useState([]);
    const [chats, setChats] = useState([]);
    const [friends, setFriends] = useState([]);
    const chatBodyRef = useRef(null);

    const [t] = useTranslation();

    useEffect(() => {
        (async () => {
            try {
                db.ref('friends').orderByChild('user').equalTo(auth().currentUser.uid)
                    .limitToFirst(10).on('value', snapshot => {
                    const friendsList = [];
                    snapshot.forEach((snap) => {
                        friendsList.push(snap.val());
                    })
                    setFriends(friendsList);
                });
            } catch (e) {
                Notification.danger(e.message)
            }
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (selectedChat) {
                db.ref('private_chat').off()
                db.ref('private_chat').orderByChild('relationKey').equalTo(selectedChat.relationKey)
                    .limitToLast(10).on('value', async snapshot => {
                    const chatList = [];
                    snapshot.forEach((snap) => {
                        chatList.push(snap.val());
                    })
                    setChats(chatList);
                    await db.ref('friends').orderByChild('relationKey').equalTo(selectedChat.relationKey)
                        .once('value', async snapshot => {
                            const keys = Object.keys(snapshot.val());
                            const values = snapshot.val();
                            if (values[keys[0]].user === auth().currentUser.uid && values[keys[0]].unreadMessage !== 0) {
                                await db.ref(`friends/${keys[0]}`).set({
                                    ...values[keys[0]],
                                    unreadMessage: 0
                                });
                            } else if (values[keys[1]].user === auth().currentUser.uid && values[keys[1]].unreadMessage !== 0) {
                                await db.ref(`friends/${keys[1]}`).set({
                                    ...values[keys[1]],
                                    unreadMessage: 0
                                });
                            }
                        });

                    const element = chatBodyRef.current;
                    element.scrollTo(0, element.scrollHeight);
                });
            }
        })()
    }, [selectedChat, friends]);

    const onSendMessage = async (message) => {
        if (message.trim() === "") {
            Notification.danger('پیام نمی تواند خالی باشد');
            return false;
        }
        try {
            const {email, displayName, photoURL, uid} = auth().currentUser;
            const {email: toEmail, displayName: toName, photoURL: toPhoto, uid: toUid} = selectedChat.friend;

            await db.ref('private_chat').push({
                message,
                relationKey: selectedChat.relationKey,
                from: {
                    uid,
                    displayName,
                    email,
                    photoURL
                },
                to: {
                    uid: toUid,
                    displayName: toName,
                    email: toEmail,
                    photoURL: toPhoto
                },
                timestamp: new Date().getTime()
            });
            await db.ref('friends').orderByChild('relationKey').equalTo(selectedChat.relationKey)
                .once('value', async snapshot => {
                    const keys = Object.keys(snapshot.val());
                    const values = snapshot.val();
                    if (values[keys[0]].user === toUid) {
                        await db.ref(`friends/${keys[0]}`).set({
                            ...values[keys[0]],
                            unreadMessage: values[keys[0]].unreadMessage + 1
                        });
                    } else {
                        await db.ref(`friends/${keys[1]}`).set({
                            ...values[keys[1]],
                            unreadMessage: values[keys[1]].unreadMessage + 1
                        });
                    }

                });

        } catch (e) {
            Notification.danger(e.message)
        }
    }

    const onSelectContact = async (contactData) => {
        if (selectedChat && contactData.friend.uid === selectedChat.friend.uid) {
            return false;
        }
        setChats([]);
        setSelectedChat(contactData);
        await db.ref('friends').orderByChild('relationKey').equalTo(contactData.relationKey)
            .once('value', async snapshot => {
                const keys = Object.keys(snapshot.val());
                const values = snapshot.val();
                if (values[keys[0]].user === auth().currentUser.uid) {
                    await db.ref(`friends/${keys[0]}`).set({
                        ...values[keys[0]],
                        unreadMessage: 0
                    });
                } else {
                    await db.ref(`friends/${keys[1]}`).set({
                        ...values[keys[1]],
                        unreadMessage: 0
                    });
                }
            });
        if (window.innerWidth <= 1200) {
            setOpenInMobile(true);
        }
    }

    const friendChangeHandler = async ({target: {value}}) => {
        setSearchFriend(value);
        if (value.length > 3) {
            try {
                await db.ref('users').orderByChild('email').startAt(value).endAt(value + "\uf8ff")
                    .limitToFirst(5).on('value', snapshot => {
                        const newSearchFriends = [];
                        snapshot.forEach((snap) => {
                            if (snap.val().uid !== auth().currentUser.uid) {
                                newSearchFriends.push(snap.val());
                            }
                        })
                        setSearchFriendList(newSearchFriends);
                    });
            } catch (e) {
                Notification.danger(e.message)
            }
        } else {
            if (searchFriendList.length > 0) {
                setSearchFriendList([]);
            }
        }
    }

    const addFriend = async (friend_data) => {
        const {email, displayName, photoURL, uid} = friend_data;
        const {
            email: currentEmail,
            displayName: currentName,
            photoURL: currentPhoto,
            uid: currentUid
        } = auth().currentUser;

        try {
            let isAlreadyAdded = false;
            await db.ref('friends').orderByChild('user').equalTo(auth().currentUser.uid)
                .once('value', async snapshot => {
                    await snapshot.forEach((snap) => {
                        if (snap.val().friend.uid === uid) {
                            isAlreadyAdded = true;
                        }
                    })
                });

            if (!isAlreadyAdded) {
                const relationKey = currentUid + RELATION_KEY + uid;
                await db.ref('friends').push({
                    user: currentUid,
                    relationKey,
                    friend: {
                        uid,
                        displayName,
                        email,
                        photoURL
                    },
                })
                await db.ref('friends').push({
                    user: uid,
                    relationKey,
                    friend: {
                        uid: currentUid,
                        displayName: currentName,
                        email: currentEmail,
                        photoURL: currentPhoto
                    },
                });
                setAddFriendModal(false);
                setSearchFriendList([]);
                setSearchFriend('');
            } else {
                Notification.danger('این مخاطب قبلا اضافه شده')
            }
        } catch (e) {
            Notification.danger(e.message)
        }
    }

    const closeOnMobileHandler = () => {
        setOpenInMobile(false);
        const timeout = setTimeout(() => {
            setSelectedChat(null);
            clearTimeout(timeout);
        }, 300);
    }

    return (
        <>
            <Main userSecTitle={t('private chat users title')}
                  userSecAction={() => <button className='simple-btn' onClick={() => setAddFriendModal(true)}>
                      <HeaderActionIcon className='fas fa-user-plus'/>
                  </button>}
                  userSecChildren={(() => {
                      return <>
                          {
                              friends.length > 0 ? friends.map((item, index) =>
                                      <UserItem
                                          key={index}
                                          active={item.friend.uid === selectedChat?.friend.uid}
                                          unreadCount={item.unreadMessage}
                                          clickHandler={() => onSelectContact(item)}
                                          imageSource={item.friend.photoURL}
                                          userName={item.friend.displayName}
                                          userStatus={item.friend.online ? 'online' : 'offline'}
                                          lastMessage={item.relationKey.split(RELATION_KEY)[0] === auth().currentUser.uid ? t('you added') : t('added you')}/>
                                  ) :
                                  <p className='my-3 text-center'>{t('no friend')}</p>
                          }
                      </>

                  })()}>
                <ChatBody inputPlaceholder={t('write')}
                          chatBodyRef={chatBodyRef}
                          openInMobile={openInMobile}
                          onSendMessage={onSendMessage}
                          isWritingMessage={selectedChat}>
                    {
                        selectedChat ?
                            <>
                                <ChatTitle classes='d-flex align-items-center justify-content-between'>
                                    <p className='mb-0'>{t('private chat title')}</p>
                                    <div className='d-flex align-items-center'>
                                        <ChatContactName>{selectedChat.friend.displayName}</ChatContactName>
                                        <ChatContactAvatar>
                                            <ChatContactImage src={selectedChat.friend.photoURL ? selectedChat.friend.photoURL : ''}
                                                              alt={selectedChat.friend.displayName}
                                                              onError={(e) => e.target.src = Placeholder}/>
                                        </ChatContactAvatar>
                                        <button className='simple-btn me-2 d-xl-none' onClick={closeOnMobileHandler}>
                                            <i className="fas fa-chevron-left main-text-color"/>
                                        </button>
                                    </div>
                                </ChatTitle>
                                <div className='px-4 pb-2'>
                                    {
                                        chats.length > 0 ? chats.map((item, index) =>
                                                <ChatContent key={index}
                                                             isSelf={item.from.uid === auth().currentUser.uid}
                                                             message={item.message}
                                                             timestamp={item.timestamp}
                                                             avatarSource={item.from.photoURL}
                                                             nickName={item.from.displayName}/>
                                            ) :
                                            <p className='my-3 text-center'>{t('no conversation')}</p>
                                    }
                                </div>
                            </> :
                            <SelectChat className='d-flex flex-column align-items-center justify-content-center'>
                                <SelfAvatarContainer>
                                    <SelfAvatar src={auth().currentUser.photoURL ? auth().currentUser.photoURL : ''} alt='My avatar'
                                                onError={(e) => e.target.src = Placeholder}/>
                                </SelfAvatarContainer>
                                <h6 className='mt-4 rtl'>{t('welcome')} {auth().currentUser.displayName}</h6>
                                <p className='mt-1 light-gray-color'
                                   style={{fontSize: '.8rem'}}>{t('select contact')}</p>
                            </SelectChat>
                    }

                </ChatBody>
            </Main>

            <Modal open={addFriendModal}
                   onClose={() => setAddFriendModal(false)}
                   classNames={{
                       modal: 'modal-container',
                       closeIcon: 'modal-close-btn'
                   }}
                   styles={{
                       closeButton: {left: t('direction') === 'lng-rtl' ? '14px' : 'unset', top: '7px', width: '22px'},
                   }}
                   center>
                <ModalDivider>
                    <ModalTitle
                        className={`mb-0 ${t('direction') === 'lng-rtl' ? 'text-end' : 'text-start'}`}>{t('add friend')}</ModalTitle>
                </ModalDivider>
                <ModalDivider>
                    <div className='d-flex w-100'>
                        <SearchInput placeholder={t('search friend')}
                                     className={t('direction')}
                                     value={searchFriend}
                                     onChange={friendChangeHandler}/>
                        <SearchIconBox className='d-flex align-items-center justify-content-center'>
                            <SearchIcon className='fas fa-search'/>
                        </SearchIconBox>
                    </div>
                </ModalDivider>

                <div className='p-3 overflow-auto' style={{maxHeight: '300px'}}>
                    {
                        searchFriendList.map((item, index) => (
                            <UserItem key={index}
                                      classes='user-item-modal'
                                      clickHandler={() => addFriend(item)}
                                      userName={item.displayName}
                                      lastMessage=''
                                      userStatus={item.online ? 'online' : 'offline'}
                                      imageSource={item.photoURL}/>
                        ))
                    }
                </div>

            </Modal>
        </>
    );
};

export default PrivateChat;
